<script>
import { mapActions, mapState } from 'vuex'

import ProgressBar from './progress-bar.vue'

export default {
  components: {
    ProgressBar,
  },

  data () {
    return {
      is_clicked: false,
      snapshot_name: null
    }
  },

  props: {
    vmInstance: {
      type: Object,
      required: true
    },
    vmControls: {
      type: Boolean,
      required: true
    },
    snapshotControls: {
      type: Boolean,
      required: true
    }
  },

  mounted: function () {
    $('[data-toggle="tooltip"]').tooltip({container: 'body'})
  },

  methods: {
    ...mapActions([
      'getCurrentReservation',
      'getImageSnapshots',
      'powerInstance',
      'revertInstanceSnapshot',
      'patchImageSnapshot',
      'postImageSnapshot',
      'loadImageSnapshot'
    ]),

    showInfo: function (event) {
      $('[data-toggle="tooltip"]').blur()
      $('#vmInfoModal' + this.vmInstance.infrastructure_instance.id).modal('show')
    },

    showSave: function (event) {
      this.getImageSnapshots()

      this.snapshot_name = null
      if(this.vmInstance.image_snapshot && this.vmInstance.image_snapshot.attributes.reservation_save_id == 0) {
        this.snapshot_name = this.vmInstance.image_snapshot.attributes.snapshot_name
      }

      $('[data-toggle="tooltip"]').blur()
      $('#vmSaveModal' + this.vmInstance.infrastructure_instance.id).modal('show')
    },

    showLoad: function (event) {
      this.getImageSnapshots()

      $('[data-toggle="tooltip"]').blur()
      $('#vmLoadModal' + this.vmInstance.infrastructure_instance.id).modal('show')
    },

    showPower: function (event) {
      $('[data-toggle="tooltip"]').blur()

      // Only
      if (this.vmInstance.infrastructure_instance.attributes.instance_status != 4) {
        return this.powerVm(event)
      }

      $('#vmPowerModal' + this.vmInstance.infrastructure_instance.id).modal('show')
    },

    powerVm: function (event) {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      $('[data-toggle="tooltip"]').blur()
      $('#vmPowerModal' + this.vmInstance.infrastructure_instance.id).modal('hide')

      let payload = {
        id: this.vmInstance.infrastructure_instance.id,
        self: this,
      }

      this.powerInstance(payload)
    },

    resetSnapshot: function (event) {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      $('[data-toggle="tooltip"]').blur()

      let payload = {
        id: this.vmInstance.infrastructure_instance.id,
        self: this,
      }

      this.revertInstanceSnapshot(payload)
    },

    replaceCurrentSnapshot: function (event) {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      $('#vmSaveModal' + this.vmInstance.infrastructure_instance.id).modal('hide')

      let payload = {
        id: this.vmInstance.infrastructure_instance.attributes.image_snapshot_id,
        json: {
          'snapshot_name': this.snapshot_name,
          'infrastructure_instance_id': this.vmInstance.infrastructure_instance.id
        },
        self: this,
      }

      this.patchImageSnapshot(payload)
    },

    saveNewSnapshot: function (event) {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      $('#vmSaveModal' + this.vmInstance.infrastructure_instance.id).modal('hide')

      let payload = {
        json: {
          'snapshot_name': this.snapshot_name,
          'infrastructure_instance_id': this.vmInstance.infrastructure_instance.id
        },
        self: this,
      }

      this.postImageSnapshot(payload)
    },

    loadSnapshot: function (event, id) {
      this.is_clicked = true
      setTimeout(function(){ this.is_clicked = false }.bind(this), 3000)

      $('#vmLoadModal' + this.vmInstance.infrastructure_instance.id).modal('hide')

      //console.log('Load Snapshot: ' + id)

      let payload = {
        id: id,
        json: {
          'infrastructure_instance_id': this.vmInstance.infrastructure_instance.id
        },
        self: this,
      }

      this.loadImageSnapshot(payload)
    },
  },

  computed: {
    ...mapState({
      reservation_transaction: state =>
        state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        ),
      infrastructure_pod: state => {
        let transaction = state.reservation.reservation_transactions.find(
          t => t.id === state.reservation.current.id
        )
        return state.infrastructure.infrastructure_pods.find(
          p => p.id === transaction.relationships.infrastructure_pod.data.id
        )
      },
      image_snapshots: state =>
        state.image.image_snapshots,
    }),

    defaultSnapshotsForVm: function () {
      let imageFlavorId = this.vmInstance.image_flavor.id
      return _.chain(this.image_snapshots)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_flavor_id == imageFlavorId &&
            item.attributes.published_at != null
        })
        // Order by column and direction
        .orderBy(['attributes.snapshot_name'], ['asc'])
        .value()
    },

    userSnapshotsForVm: function () {
      let imageFlavorId = this.vmInstance.image_flavor.id
      return _.chain(this.image_snapshots)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.image_flavor_id == imageFlavorId &&
            item.attributes.published_at == null
        })
        // Order by column and direction
        .orderBy(['attributes.snapshot_name'], ['asc'])
        .value()
    },

    userSnapshots: function () {
      return _.chain(this.image_snapshots)
        // Filter by image tier id
        .filter(function (item) {
          return item.attributes.published_at == null &&
            item.attributes.reservation_save_id == 0
        })
        // Order by column and direction
        .orderBy(['attributes.snapshot_name'], ['asc'])
        .value()
    },

    userSnapshotsTotal: function () {
      return this.userSnapshots ? this.userSnapshots.length : 0
    },

    snapshotLimit: function () {
      return Labstack.snapshot_limit
    },

    snapshotExpires: function () {
      return Labstack.snapshot_expires
    },

    isOnStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 3
    },

    isOffStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 4
    },

    isProvisioningStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 2
    },

    isErrorStatus: function () {
      return this.vmInstance.infrastructure_instance &&
        this.vmInstance.infrastructure_instance.attributes.instance_status == 9
    },

    isSnapshotDisabled: function () {
      return ! this.snapshotControls || this.isDisabled
    },

    isVmControlDisabled: function () {
      return ! this.vmControls || this.isDisabled
    },

    isDisabled: function () {
      return this.is_clicked ||
        (
          this.reservation_transaction &&
          // Pending status
          this.infrastructure_pod.attributes.pod_status == 2
        )
    }
  }
}
</script>
